import {
    faChartBar,
    faVideo,
    faHouse,
    faServer,
    faKey,
    faFile,
    faUserShield,
    faNetworkWired,
    faCloud,
    faCar,
    faDatabase,
    faMobileScreen,
    faLock,
    faUsers,
    faCreditCard,
    faBolt,
    faBell,
    faDoorOpen,
    faClipboardList,
    faFolder,
    faCamera,
    faGlobe,
    faLink,
    faEnvelope,
    faAddressCard,
    faLocationDot,
    faStore,
    faTrash,
    faShield,
    faWifi,
    faToolbox,
    faScrewdriverWrench,
    faGears,
    faMusic
  } from "@fortawesome/free-solid-svg-icons";
  
  export const RIGHT_LABELS = {
    // -------------------- Core TDS Services --------------------
    "net.thomasdye.TDS-reporting": {
      label: "Reporting",
      icon: faChartBar,
      path: "",
      description: "Create and view reports"
    },
    "net.thomasdye.TDS-CCTV": {
      label: "CCTV",
      icon: faCamera,
      path: "http://30.0.1.5",
      description: "Live feeds & recordings"
    },
    "net.thomasdye.TDS-RDS": {
      label: "RDS",
      icon: faServer,
      path: "",
      description: "Remote desktop services"
    },
    "net.thomasdye.TDS-serverstatus": {
      label: "Server Status",
      icon: faServer,
      path: "/server-status",
      description: "Overall status dashboard"
    },
    "net.thomasdye.TDS-serverstatus.CoreServers": {
      label: "Infra Control",
      icon: faServer,
      path: "/infra/hosts",
      description: "View core hosts"
    },
    "net.thomasdye.TDS-Home": {
      label: "Smart Home",
      icon: faHouse,
      path: "/",
      description: "Home automation overview"
    },
    "net.thomasdye.TDS-Home.DoorAccess": {
      label: "Door Access",
      icon: faDoorOpen,
      path: "",
      description: "Lock/unlock & audit (IOS)"
    },
    "net.thomasdye.TDS-Auth-flow": {
      label: "Auth Flow",
      icon: faKey,
      path: "/auth-flow",
      description: "Authentication & SSO (Test Flow)"
    },
    "net.thomasdye.TDS-doc-store": {
      label: "Document Store",
      icon: faFile,
      path: "",
      description: "Browse and manage documents (IOS)"
    },
    "net.thomasdye.TDS-Guest.Party": {
      label: "Guest: Party",
      icon: faAddressCard,
      path: "https://party.thomasdye.net",
      description: "Event guest management"
    },
    "net.thomasdye.TDS-mercedes-benz": {
      label: "Mercedes-Benz",
      icon: faCar,
      path: "",
      description: "Vehicle status & controls (IOS)"
    },
    "net.thomasdye.TDS-SkyQ": {
      label: "Sky Q",
      icon: faVideo,
      path: "",
      description: "Sky Q control & status (IOS)"
    },
    "net.thomasdye.TDS-Be-Real": {
      label: "BeReal Tools",
      icon: faBolt,
      path: "",
      description: "Automations & utilities (IOS)"
    },
    // "net.thomasdye.AppleMusic-SP": {
    //   label: "Apple Music (SP)",
    //   icon: faMusic, // <-- If faMusic not imported, change to faBolt or add faMusic
    //   path: "",
    //   description: "Apple Music service provider (IOS)"
    // },
    "net.thomasdye.Web.HomeserverLogs": {
      label: "Homeserver Logs",
      icon: faDatabase,
      path: "https://homeserverapilocal.server.thomasdye.net/",
      description: "Web-accessible logs"
    },
    "net.thomasdye.TDS-Song-Converter": {
      label: "Song Converter",
      icon: faBolt,
      path: "",
      description: "Audio conversion utilities"
    },
    "net.thomasdye.TDS-LocationTracking": {
      label: "Location Tracking",
      icon: faLocationDot,
      path: "",
      description: "Devices & geofences (IOS)"
    },
    "net.thomasdye.TDS-User-Managment": {
      label: "User Management",
      icon: faUsers,
      path: "/users",
      description: "Manage user accounts"
    },
    "net.thomasdye.TDS-door-keypad": {
      label: "Door Keypad",
      icon: faDoorOpen,
      path: "",
      description: "TDS PINs & keypad settings (Door Access SUB)"
    },
    "net.thomasdye.TDS-home-websocket": {
      label: "Home WebSocket",
      icon: faWifi,
      path: "https://homeserverapilocal.server.thomasdye.net/",
      description: "Realtime home Streaming API"
    },
    "net.thomasdye.tds-empapp": {
      label: "Employee App",
      icon: faUsers,
      path: "/employee",
      description: "Internal employee portal"
    },
    "net.thomasdye.TDSPolice": {
      label: "TDS Police",
      icon: faShield,
      path: "",
      description: "Security & enforcement tools (IOS)"
    },
    "net.thomasdye.internal.networking.TDS-InCar": {
      label: "Networking: In-Car",
      icon: faNetworkWired,
      path: "",
      description: "In-car networking"
    },
    "net.thomasdye.internal.networking": {
      label: "Internal Networking",
      icon: faNetworkWired,
      path: "",
      description: "Networks & links"
    },
    "net.thomasdye.internal.VPN.Main": {
      label: "VPN (Main)",
      icon: faLink,
      path: "",
      description: "Primary VPN tunnel"
    },
    "net.thomasdye.internal.VPN.V2": {
      label: "VPN (V2)",
      icon: faLink,
      path: "",
      description: "Secondary VPN tunnel"
    },
    "net.thomasdye.internal.testing": {
      label: "Internal Testing",
      icon: faToolbox,
      path: "",
      description: "Labs & experiments"
    },
    "net.thomasdye.SmartHome.internal": {
      label: "SmartHome (Internal)",
      icon: faHouse,
      path: "https://homeserverapilocal.server.thomasdye.net/",
      description: "Back-of-house controls"
    },
    "net.thomasdye.internal": {
      label: "Internal",
      icon: faGears,
      path: "",
      description: "Internal systems"
    },
    "net.thomasdye.grafana": {
      label: "Grafana",
      icon: faChartBar,
      path: "https://grafana.thomasdye.net",
      description: "Dashboards & metrics"
    },
    "net.thomasdye.TDS-House-intercom": {
      label: "House Intercom",
      icon: faBell,
      path: "",
      description: "Intercom controls & logs (IOS)"
    },
    "net.thomasdye.CloudServer": {
      label: "Cloud Server",
      icon: faCloud,
      path: "https://cloud.thomasdye.net",
      description: "Cloud host controls"
    },
    "net.thomasdye.TDS-User-Managment.fullSystemAdmin": {
      label: "User Mgmt: Full Admin",
      icon: faUserShield,
      path: "",
      description: "Full system admin rights"
    },
    "net.thomasdye.TDS-User-Managment.selfmanage": {
      label: "User Mgmt: Self-Manage",
      icon: faUsers,
      path: "",
      description: "Self-service controls (MDM APP)"
    },
    "net.thomasdye.TDS-User-Managment.selfemail": {
      label: "User Mgmt: Self Email",
      icon: faEnvelope,
      path: "/users/self/email",
      description: "Email self-service (MDM APP)"
    },
    "net.thomasdye.Mail": {
      label: "Mail",
      icon: faEnvelope,
      path: "",
      description: "Mail tools & settings (Mail server)"
    },
    "net.thomasdye.web.wordpress.thomas": {
      label: "WordPress (Thomas)",
      icon: faGlobe,
      path: "https://thomasdye.net",
      description: "Site management"
    },
    "net.thomasdye.TDS-McdonaldsApi": {
      label: "McDonalds API",
      icon: faBolt,
      path: "",
      description: "API tools & data"
    },
    "net.thomasdye.web.home.Manageservices": {
      label: "Manage Services",
      icon: faScrewdriverWrench,
      path: "https://homeserverapilocal.server.thomasdye.net/",
      description: "Service catalogue admin"
    },
    "net.thomasdye.web.TokenAndKeyServer": {
      label: "Token & Key Server",
      icon: faKey,
      path: "http://auth.local.thomasdye.net:9994",
      description: "Token and key management"
    },
    "net.thomasdye.profilemanager.admin": {
      label: "Profile Manager Admin",
      icon: faUserShield,
      path: "https://device.server.thomasdye.net",
      description: "Admin console"
    },
    "net.thomasdye.profilemanager.devices.all": {
      label: "PM: Devices (All)",
      icon: faMobileScreen,
      path: "https://device.server.thomasdye.net",
      description: "All devices"
    },
    "net.thomasdye.profilemanager.apps.all": {
      label: "PM: Apps (All)",
      icon: faStore,
      path: "https://device.server.thomasdye.net",
      description: "All apps"
    },
    "net.thomasdye.profilemanager.profiles.all": {
      label: "PM: Profiles (All)",
      icon: faFolder,
      path: "https://device.server.thomasdye.net",
      description: "All profiles"
    },
    "net.thomasdye.profilemanager.delete.all": {
      label: "PM: Delete (All)",
      icon: faTrash,
      path: "https://device.server.thomasdye.net",
      description: "Deletion rights"
    },
    "net.thomasdye.profilemanager.create.all": {
      label: "PM: Create (All)",
      icon: faClipboardList,
      path: "https://device.server.thomasdye.net",
      description: "Creation rights"
    },
    "net.thomasdye.profilemanager.events.all": {
      label: "PM: Events (All)",
      icon: faDatabase,
      path: "https://device.server.thomasdye.net",
      description: "Event logs"
    },
    "net.thomasdye.mydevice": {
      label: "My Device",
      icon: faMobileScreen,
      path: "https://device.server.thomasdye.net",
      description: "Personal device page"
    },
    "net.thomasdye.TDS-MDM.SSO": {
      label: "MDM SSO",
      icon: faLock,
      path: "",
      description: "Single sign-on"
    },
    "net.thomasdye.TDS-doc-store.admin": {
      label: "Doc Store Admin",
      icon: faUserShield,
      path: "",
      description: "Document admin rights (IOS)"
    },
    "net.thomasdye.TDS-doc-store.readonly": {
      label: "Doc Store Readonly",
      icon: faFile,
      path: "",
      description: "Read-only access (IOS)"
    },
    "net.thomasdye.TDS-doc-store.canAddUser": {
      label: "Doc Store: Add User",
      icon: faUsers,
      path: "",
      description: "Invite/manage users (IOS)"
    },
    "net.thomasdye.TDS-doc-store.can_see_user": {
      label: "Doc Store: View Users",
      icon: faUsers,
      path: "",
      description: "View user list (IOS)"
    },
    "net.thomasdye.TDS-doc-store.can_see_Deleted": {
      label: "Doc Store: Deleted",
      icon: faTrash,
      path: "",
      description: "View deleted items (IOS)"
    },
    "net.thomasdye.TDS-VPN": {
      label: "TDS VPN",
      icon: faLink,
      path: "",
      description: "VPN access controls (IOS)"
    },
    "net.thomasdye.TDS-MDM.PSSO.login": {
      label: "MDM PSSO Login",
      icon: faLock,
      path: "",
      description: "Platform SSO login (MacOS)"
    },
    "net.thomasdye.TDS.PSSO.Group.Mac.Adamin": {
      label: "PSSO Group Mac (Admin)",
      icon: faUserShield,
      path: "/psso/groups/mac-admin",
      description: "Group entitlement (Mac)"
    },
    "net.thomasdye.Photos-Store": {
      label: "TDS Obsidian",
      icon: faFolder,
      path: "",
      description: "TDS Obsidian"
    },
    "net.thomasdye.TDSHttpProxy": {
      label: "HTTP Proxy",
      icon: faGlobe,
      path: "",
      description: "HTTP proxy controls"
    },
    "net.thomasdye.TDS-Video": {
      label: "TDS Video",
      icon: faVideo,
      path: "",
      description: "Carplay Streaming service Login (Testing)"
    },
    "net.thomasdye.internal.VPN.USG": {
      label: "VPN — USG",
      icon: faLink,
      path: "",
      description: "USG tunnel"
    },
    "net.thomasdye.internal.VPN.TomsHouse": {
      label: "VPN — Tom’s House",
      icon: faLink,
      path: "",
      description: "Toms Home tunnel"
    },
    "net.thomasdye.TDS-Reporting-V2": {
      label: "Reporting v2",
      icon: faChartBar,
      path: "",
      description: "Next-gen reporting (IOS)"
    },
    "net.thomasdye.TDS-Reporting-V2.Manage": {
      label: "Reporting v2 (Manage)",
      icon: faScrewdriverWrench,
      path: "",
      description: "Administer reporting"
    },
    // "net.thomasdye.TDS-Cloud": {
    //   label: "TDS Cloud",
    //   icon: faCloud,
    //   path: "",
    //   description: "Cloud services"
    // },
    "net.thomasdye.TDS-MDM": {
      label: "MDM",
      icon: faMobileScreen,
      path: "https://device.server.thomasdye.net",
      description: "Device management"
    },
    "net.thomasdye.Payments.FullAccess": {
      label: "Payments",
      icon: faCreditCard,
      path: "https://payments.thomasdye.net/admin/",
      description: "Payments & billing"
    },
    // "net.thomasdye.YouTubeView": {
    //   label: "YouTube View",
    //   icon: faBolt,
    //   path: "/youtube",
    //   description: "YouTube analytics"
    // },
    "net.thomasdye.n8n": {
      label: "n8n Automation",
      icon: faNetworkWired,
      path: "https://n8n.local.thomasdye.net/",
      description: "Workflows & tasks"
    },
  
    // -------------------- APNS Services --------------------
    "net.thomasdye.APNS.SideGateBell": {
      label: "APNS: Side Gate Bell",
      icon: faBell,
      path: "",
      description: "Doorbell push notifications"
    },
    "net.thomasdye.APNS.SideGateBell_Events": {
      label: "APNS: Side Gate Events",
      icon: faBell,
      path: "",
      description: "Event notifications"
    },
    "net.thomasdye.APNS.ThomasRoomDoor": {
      label: "APNS: Thomas Room Door",
      icon: faDoorOpen,
      path: "",
      description: "Room door alerts"
    },
    "net.thomasdye.APNS.TomsHouseEvents": {
      label: "APNS: Tom’s House Events",
      icon: faBell,
      path: "",
      description: "House event notifications"
    },
    "net.thomasdye.APNS.ServerStatus": {
      label: "APNS: Server Status",
      icon: faServer,
      path: "",
      description: "Server health alerts"
    },
    "net.thomasdye.APNS.MB.ThomasCar": {
      label: "APNS: Thomas’s Car",
      icon: faCar,
      path: "",
      description: "Vehicle notifications"
    },
    "net.thomasdye.APNS.UPSPower": {
      label: "APNS: UPS Power",
      icon: faBolt,
      path: "",
      description: "Power notifications"
    },
    "net.thomasdye.APNS.TDSReporting.Group1": {
      label: "APNS: Reporting G1",
      icon: faChartBar,
      path: "",
      description: "Reporting group feed"
    },
    "net.thomasdye.APNS.TDSReporting.Group2": {
      label: "APNS: Reporting G2",
      icon: faChartBar,
      path: "",
      description: "Reporting group feed"
    },
    "net.thomasdye.APNS.TDSReporting.Group3": {
      label: "APNS: Reporting G3",
      icon: faChartBar,
      path: "",
      description: "Reporting group feed"
    },
    "net.thomasdye.APNS.TDSReporting.Group4": {
      label: "APNS: Reporting G4",
      icon: faChartBar,
      path: "",
      description: "Reporting group feed"
    }
  };
  